module.exports = __webpack_public_path__ + "img/id_in_doubt_wash_your_hair.a38246cb.jpg";